import { render } from "./OrderPaymentsModal.vue?vue&type=template&id=19656369"
import script from "./OrderPaymentsModal.vue?vue&type=script&lang=js"
export * from "./OrderPaymentsModal.vue?vue&type=script&lang=js"

import "./OrderPaymentsModal.vue?vue&type=style&index=0&id=19656369&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__